import 'assets/css/nucleo-icons.css';
import 'assets/css/nucleo-svg.css';
import 'assets/css/font-awesome.css';

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import theme from './assets/theme';

import AppRoutes from 'routes/routes';
import { AuthProvider } from 'auth/AuthContext';
import { CartProvider } from 'context/CartContext';
import { PkgProvider } from 'context/PkgContext';

const queryClient = new QueryClient();

export default function App() {
  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <PkgProvider>
          <QueryClientProvider client={queryClient}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <CartProvider>
                <AppRoutes />
              </CartProvider>
            </LocalizationProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </PkgProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
